// Monta a URL do visualizador de PDF usado na aula (web).
//
// Preferimos o pdf.js que o próprio core serve em `/pdf.js/` — mesma origem da
// área de membros, tanto no subdomínio `.herospark.co` quanto nos domínios
// próprios das escolas. Esse build é atual e recebe os patches da HeroSpark; o
// bundle antigo hospedado no static-cdn continua só como fallback.
//
// O `file` precisa ser da mesma origem do visualizador: o pdf.js valida isso em
// `validateFileURL` e recusa a URL assinada do CDN. Por isso apontamos para a
// rota do core, que autentica pela sessão e redireciona para o arquivo (com DRM
// quando o curso pede). De quebra, a URL assinada deixa de aparecer no DOM.

const CORE_VIEWER_PATH = '/pdf.js/web/viewer.html'
const LEGACY_VIEWER_URL =
  'https://static-cdn.myedools.com/pdfjs/web/viewer.html'

/** `useLocalSearchParams` devolve `string | string[]`; a rota usa um id só. */
function firstParam(value?: string | string[]): string | null {
  const raw = Array.isArray(value) ? value[0] : value
  const trimmed = raw?.trim()
  return trimmed || null
}

interface IBuildPdfViewerUrlParams {
  courseId?: string | string[]
  mediaId?: number | null
  fileUrl?: string | null
}

/**
 * URL do visualizador para o PDF da aula, ou `null` quando não há nada para
 * abrir. Fora da rota de curso (ex.: pré-visualização sem `courseId`) cai no
 * visualizador antigo com o arquivo direto.
 */
export function buildPdfViewerUrl({
  courseId,
  mediaId,
  fileUrl,
}: IBuildPdfViewerUrlParams): string | null {
  const course = firstParam(courseId)

  if (course && mediaId) {
    const file = `/course/${encodeURIComponent(
      course,
    )}/media/${encodeURIComponent(String(mediaId))}/download.pdf`

    return `${CORE_VIEWER_PATH}?file=${encodeURIComponent(file)}`
  }

  if (fileUrl) {
    return `${LEGACY_VIEWER_URL}?file=${encodeURIComponent(fileUrl)}`
  }

  return null
}
